/* tslint:disable */
/* eslint-disable */
/**
 * mindd-stim3-home-api-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CheckInReminderOptOut } from '../model';
// @ts-ignore
import type { CreateTherapyCheckInRequest } from '../model';
// @ts-ignore
import type { MyTherapyCheckIns } from '../model';
// @ts-ignore
import type { TherapyCheckIn } from '../model';
// @ts-ignore
import type { UpdateCheckInReminderOptOutRequest } from '../model';
// @ts-ignore
import type { UpdateTherapyCheckInRequest } from '../model';
/**
 * MyTherapyCheckInControllerApi - axios parameter creator
 * @export
 */
export const MyTherapyCheckInControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 오늘 또는 일정상 직전 자극일만 작성할 수 있다. 목표 치료 횟수에 도달하면 거부한다.
         * @summary 치료 체크인 작성 (환자)
         * @param {string} prescriptionId 
         * @param {CreateTherapyCheckInRequest} createTherapyCheckInRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1: async (prescriptionId: string, createTherapyCheckInRequest: CreateTherapyCheckInRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('create1', 'prescriptionId', prescriptionId)
            // verify required parameter 'createTherapyCheckInRequest' is not null or undefined
            assertParamExists('create1', 'createTherapyCheckInRequest', createTherapyCheckInRequest)
            const localVarPath = `/api/v1/me/prescriptions/{prescriptionId}/check-ins`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTherapyCheckInRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 작성한 체크인 원본을 최신 날짜순으로 돌려준다. 격자·회차·진행률은 앱이 처방의 param.dates·treatmentCount 와 조합해 그린다. writableDates 는 새로 쓸 수 있는 날짜, editableDates 는 이미 쓴 기록 중 지금 고칠 수 있는 날짜다.
         * @summary 치료 체크인 내역 조회 (환자)
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHistory: async (prescriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('findHistory', 'prescriptionId', prescriptionId)
            const localVarPath = `/api/v1/me/prescriptions/{prescriptionId}/check-ins`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 한 번도 바꾼 적이 없으면 optedOut=false, changedTime=null 이다.
         * @summary 체크인 리마인더 수신 거부 상태 조회 (환자)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReminderOptOut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/check-in-reminder-opt-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 오늘 또는 일정상 직전 자극일의 기록만 수정할 수 있다.
         * @summary 치료 체크인 수정 (환자)
         * @param {string} checkInId 
         * @param {UpdateTherapyCheckInRequest} updateTherapyCheckInRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (checkInId: string, updateTherapyCheckInRequest: UpdateTherapyCheckInRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkInId' is not null or undefined
            assertParamExists('update', 'checkInId', checkInId)
            // verify required parameter 'updateTherapyCheckInRequest' is not null or undefined
            assertParamExists('update', 'updateTherapyCheckInRequest', updateTherapyCheckInRequest)
            const localVarPath = `/api/v1/me/check-ins/{checkInId}`
                .replace(`{${"checkInId"}}`, encodeURIComponent(String(checkInId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTherapyCheckInRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 환자 한 사람 단위로 적용된다. 기관·처방과 무관하며 이후 새로 생기는 처방에도 적용된다. 멱등이라 같은 값을 다시 보내도 성공한다. 체크인 작성·조회에는 영향이 없다.
         * @summary 체크인 리마인더 수신 거부 설정 (환자)
         * @param {UpdateCheckInReminderOptOutRequest} updateCheckInReminderOptOutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReminderOptOut: async (updateCheckInReminderOptOutRequest: UpdateCheckInReminderOptOutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCheckInReminderOptOutRequest' is not null or undefined
            assertParamExists('updateReminderOptOut', 'updateCheckInReminderOptOutRequest', updateCheckInReminderOptOutRequest)
            const localVarPath = `/api/v1/me/check-in-reminder-opt-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCheckInReminderOptOutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyTherapyCheckInControllerApi - functional programming interface
 * @export
 */
export const MyTherapyCheckInControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MyTherapyCheckInControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 오늘 또는 일정상 직전 자극일만 작성할 수 있다. 목표 치료 횟수에 도달하면 거부한다.
         * @summary 치료 체크인 작성 (환자)
         * @param {string} prescriptionId 
         * @param {CreateTherapyCheckInRequest} createTherapyCheckInRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create1(prescriptionId: string, createTherapyCheckInRequest: CreateTherapyCheckInRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyCheckIn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create1(prescriptionId, createTherapyCheckInRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MyTherapyCheckInControllerApi.create1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 작성한 체크인 원본을 최신 날짜순으로 돌려준다. 격자·회차·진행률은 앱이 처방의 param.dates·treatmentCount 와 조합해 그린다. writableDates 는 새로 쓸 수 있는 날짜, editableDates 는 이미 쓴 기록 중 지금 고칠 수 있는 날짜다.
         * @summary 치료 체크인 내역 조회 (환자)
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findHistory(prescriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyTherapyCheckIns>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findHistory(prescriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MyTherapyCheckInControllerApi.findHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 한 번도 바꾼 적이 없으면 optedOut=false, changedTime=null 이다.
         * @summary 체크인 리마인더 수신 거부 상태 조회 (환자)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReminderOptOut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckInReminderOptOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findReminderOptOut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MyTherapyCheckInControllerApi.findReminderOptOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 오늘 또는 일정상 직전 자극일의 기록만 수정할 수 있다.
         * @summary 치료 체크인 수정 (환자)
         * @param {string} checkInId 
         * @param {UpdateTherapyCheckInRequest} updateTherapyCheckInRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(checkInId: string, updateTherapyCheckInRequest: UpdateTherapyCheckInRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyCheckIn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(checkInId, updateTherapyCheckInRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MyTherapyCheckInControllerApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 환자 한 사람 단위로 적용된다. 기관·처방과 무관하며 이후 새로 생기는 처방에도 적용된다. 멱등이라 같은 값을 다시 보내도 성공한다. 체크인 작성·조회에는 영향이 없다.
         * @summary 체크인 리마인더 수신 거부 설정 (환자)
         * @param {UpdateCheckInReminderOptOutRequest} updateCheckInReminderOptOutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReminderOptOut(updateCheckInReminderOptOutRequest: UpdateCheckInReminderOptOutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckInReminderOptOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReminderOptOut(updateCheckInReminderOptOutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MyTherapyCheckInControllerApi.updateReminderOptOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MyTherapyCheckInControllerApi - factory interface
 * @export
 */
export const MyTherapyCheckInControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MyTherapyCheckInControllerApiFp(configuration)
    return {
        /**
         * 오늘 또는 일정상 직전 자극일만 작성할 수 있다. 목표 치료 횟수에 도달하면 거부한다.
         * @summary 치료 체크인 작성 (환자)
         * @param {string} prescriptionId 
         * @param {CreateTherapyCheckInRequest} createTherapyCheckInRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1(prescriptionId: string, createTherapyCheckInRequest: CreateTherapyCheckInRequest, options?: any): AxiosPromise<TherapyCheckIn> {
            return localVarFp.create1(prescriptionId, createTherapyCheckInRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 작성한 체크인 원본을 최신 날짜순으로 돌려준다. 격자·회차·진행률은 앱이 처방의 param.dates·treatmentCount 와 조합해 그린다. writableDates 는 새로 쓸 수 있는 날짜, editableDates 는 이미 쓴 기록 중 지금 고칠 수 있는 날짜다.
         * @summary 치료 체크인 내역 조회 (환자)
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHistory(prescriptionId: string, options?: any): AxiosPromise<MyTherapyCheckIns> {
            return localVarFp.findHistory(prescriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 한 번도 바꾼 적이 없으면 optedOut=false, changedTime=null 이다.
         * @summary 체크인 리마인더 수신 거부 상태 조회 (환자)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReminderOptOut(options?: any): AxiosPromise<CheckInReminderOptOut> {
            return localVarFp.findReminderOptOut(options).then((request) => request(axios, basePath));
        },
        /**
         * 오늘 또는 일정상 직전 자극일의 기록만 수정할 수 있다.
         * @summary 치료 체크인 수정 (환자)
         * @param {string} checkInId 
         * @param {UpdateTherapyCheckInRequest} updateTherapyCheckInRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(checkInId: string, updateTherapyCheckInRequest: UpdateTherapyCheckInRequest, options?: any): AxiosPromise<TherapyCheckIn> {
            return localVarFp.update(checkInId, updateTherapyCheckInRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 환자 한 사람 단위로 적용된다. 기관·처방과 무관하며 이후 새로 생기는 처방에도 적용된다. 멱등이라 같은 값을 다시 보내도 성공한다. 체크인 작성·조회에는 영향이 없다.
         * @summary 체크인 리마인더 수신 거부 설정 (환자)
         * @param {UpdateCheckInReminderOptOutRequest} updateCheckInReminderOptOutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReminderOptOut(updateCheckInReminderOptOutRequest: UpdateCheckInReminderOptOutRequest, options?: any): AxiosPromise<CheckInReminderOptOut> {
            return localVarFp.updateReminderOptOut(updateCheckInReminderOptOutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MyTherapyCheckInControllerApi - object-oriented interface
 * @export
 * @class MyTherapyCheckInControllerApi
 * @extends {BaseAPI}
 */
export class MyTherapyCheckInControllerApi extends BaseAPI {
    /**
     * 오늘 또는 일정상 직전 자극일만 작성할 수 있다. 목표 치료 횟수에 도달하면 거부한다.
     * @summary 치료 체크인 작성 (환자)
     * @param {string} prescriptionId 
     * @param {CreateTherapyCheckInRequest} createTherapyCheckInRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTherapyCheckInControllerApi
     */
    public create1(prescriptionId: string, createTherapyCheckInRequest: CreateTherapyCheckInRequest, options?: RawAxiosRequestConfig) {
        return MyTherapyCheckInControllerApiFp(this.configuration).create1(prescriptionId, createTherapyCheckInRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 작성한 체크인 원본을 최신 날짜순으로 돌려준다. 격자·회차·진행률은 앱이 처방의 param.dates·treatmentCount 와 조합해 그린다. writableDates 는 새로 쓸 수 있는 날짜, editableDates 는 이미 쓴 기록 중 지금 고칠 수 있는 날짜다.
     * @summary 치료 체크인 내역 조회 (환자)
     * @param {string} prescriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTherapyCheckInControllerApi
     */
    public findHistory(prescriptionId: string, options?: RawAxiosRequestConfig) {
        return MyTherapyCheckInControllerApiFp(this.configuration).findHistory(prescriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 한 번도 바꾼 적이 없으면 optedOut=false, changedTime=null 이다.
     * @summary 체크인 리마인더 수신 거부 상태 조회 (환자)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTherapyCheckInControllerApi
     */
    public findReminderOptOut(options?: RawAxiosRequestConfig) {
        return MyTherapyCheckInControllerApiFp(this.configuration).findReminderOptOut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 오늘 또는 일정상 직전 자극일의 기록만 수정할 수 있다.
     * @summary 치료 체크인 수정 (환자)
     * @param {string} checkInId 
     * @param {UpdateTherapyCheckInRequest} updateTherapyCheckInRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTherapyCheckInControllerApi
     */
    public update(checkInId: string, updateTherapyCheckInRequest: UpdateTherapyCheckInRequest, options?: RawAxiosRequestConfig) {
        return MyTherapyCheckInControllerApiFp(this.configuration).update(checkInId, updateTherapyCheckInRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 환자 한 사람 단위로 적용된다. 기관·처방과 무관하며 이후 새로 생기는 처방에도 적용된다. 멱등이라 같은 값을 다시 보내도 성공한다. 체크인 작성·조회에는 영향이 없다.
     * @summary 체크인 리마인더 수신 거부 설정 (환자)
     * @param {UpdateCheckInReminderOptOutRequest} updateCheckInReminderOptOutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTherapyCheckInControllerApi
     */
    public updateReminderOptOut(updateCheckInReminderOptOutRequest: UpdateCheckInReminderOptOutRequest, options?: RawAxiosRequestConfig) {
        return MyTherapyCheckInControllerApiFp(this.configuration).updateReminderOptOut(updateCheckInReminderOptOutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

